/**
 * Super admin — all-company MCP agent audit log
 */

import { useQuery } from '@tanstack/react-query'
import { loadAdminAgentActivity } from '../../api/mcp'

export default function AdminAgentActivityScreen() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-agent-activity'],
    queryFn: () => loadAdminAgentActivity({ limit: 200 }),
    staleTime: 30_000,
  })
  const rows = data?.rows ?? []
  const registrations = data?.registrations ?? []

  return (
    <div className="admin-page" data-testid="admin-agent-activity-page">
      <h1 className="admin-page-title">Agent activity</h1>
      <p className="admin-page-sub">MCP tool calls across all companies (read audit log)</p>
      {registrations.length > 0 && (
        <>
          <h2 style={{ fontSize: 16, marginTop: 24 }}>OAuth client registrations (DCR)</h2>
          <table className="admin-table" style={{ width: '100%', fontSize: 13, marginBottom: 28 }}>
            <thead>
              <tr>
                <th>Registered</th>
                <th>Name</th>
                <th>Client ID</th>
                <th>IP</th>
                <th>Last used</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {registrations.map((r) => (
                <tr key={r.client_id}>
                  <td>{new Date(r.created_at).toLocaleString()}</td>
                  <td>{r.client_name}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{r.client_id}</td>
                  <td>{r.registrant_ip ?? '—'}</td>
                  <td>{r.last_used_at ? new Date(r.last_used_at).toLocaleString() : '—'}</td>
                  <td>{r.revoked_at ? 'Revoked' : 'Active'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {isLoading ? (
        <p>Loading…</p>
      ) : (
        <table className="admin-table" style={{ width: '100%', fontSize: 13 }}>
          <thead>
            <tr>
              <th>When</th>
              <th>Company</th>
              <th>User</th>
              <th>Client</th>
              <th>Tool</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{new Date(r.created_at).toLocaleString()}</td>
                <td>{(r as { company_id?: number }).company_id ?? '—'}</td>
                <td>{(r as { user_id?: number }).user_id ?? '—'}</td>
                <td>{r.client_name}</td>
                <td>{r.tool}</td>
                <td>{r.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
